// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';
/**
 * 基础菜单
 */
// 会员列表
import Goods from '@/views/goods/Goods';
// 订单管理
import Order from '@/views/pay/Order';
import Complaint from '@/views/pay/Complaint';

/**
 * 系统管理
 */
// 提现发放
import user from '@/views/system/user';
// 菜单管理
import Module from '@/views/system/Module';
// VPN线路管理
import Role from '@/views/system/Role';
import linkCountOnline from '@/views/system/linkCountOnline';
import cityVoteResult from '@/views/system/cityVoteResult';
import vpnRefreshTime from '@/views/system/vpnRefreshTime';

// 地区管理
import Dept from '@/views/system/Dept';
// 提现审核
import Variable from '@/views/system/Variable';
// 权限管理
import Permission from '@/views/system/Permission';
/**
 * 支付管理
 */
// VPN套餐 / 通知管理
import MachineConfigPhone from '@/views/machine/MachineConfigPhone';
import MachineConfig from '@/views/machine/MachineConfig';
import auditquery from '@/views/machine/auditquery';
import addquery from '@/views/machine/addquery';

import appVersion from '@/views/machine/appVersion';

import notice from '@/views/machine/notice';
import feedBack from '@/views/machine/feedBack';
import appstore from '@/views/machine/appstore';
// 支付配置
import Config from '@/views/pay/Config';
/**
 * 数据监控
 */
// 图表界面
import statistics from '@/views/charts/statistics';

import statistics_phone from '@/views/charts/statistics_phone';
// 每日会员付费分析
import vipTypeDaily from '@/views/charts/vipTypeDaily';
// 客诉记录
import customer from '@/views/complaints/page';
import actcode from '@/views/actcode/codepage'
import actcodespace from '@/views/actcode/space'
import channelspace from '@/views/actcode/channelspace'
import spacereport from '@/views/actcode/spacereport'
import channeluser from '@/views/goods/channeluser'
import inviteuser from '@/views/goods/inviteuser'
// 白名单管理
import whitelist from '@/views/whitelist/index'
// 微信凭证日志
import wxtoken from '@/views/wxtoken/index'


// 启用路由
Vue.use(Router);

let routes =
routes = [{
    path: '/',
    name: '',
    component: login,
    hidden: true,
    meta: {
        requireAuth: false
    }
}, {
    path: '/login',
    name: '登录',
    component: login,
    hidden: true,
    meta: {
        requireAuth: false
    }
},
{
    path: '/index',
    name: '首页',
    component: index,
    iconCls: 'el-icon-tickets',
    children: [
        {
            path: '/charts/statistics',
            name: '运营数据看板',
            component: statistics,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/charts/statistics_phone',
            name: '运营数据看板(手机)',
            component: statistics_phone,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/charts/vipTypeDaily',
            name: '每日会员付费分析',
            component: vipTypeDaily,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/goods/Goods',
            name: '会员列表',
            component: Goods,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/pay/Order',
            name: '订单管理',
            component: Order,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/pay/Complaint',
            name: '投诉管理',
            component: Complaint,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/user',
            name: '提现发放',
            component: user,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Module',
            name: '菜单管理',
            component: Module,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Role',
            name: 'VPN线路管理',
            component: Role,
            meta: {
                requireAuth: true
            }
        },{
            path: '/report/vpnRefreshTime',
            name: 'VPN更新时间',
            component: vpnRefreshTime,
            meta: {
                requireAuth: true
            }
        },{
            path: '/report/cityVoteResult',
            name: '城市投票',
            component: cityVoteResult,
            meta: {
                requireAuth: true
            }
        },{
            path: '/report/linkCountOnline',
            name: '在线连接',
            component: linkCountOnline,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Dept',
            name: '地区管理',
            component: Dept,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Variable',
            name: '提现审核',
            component: Variable,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Permission',
            name: '权限管理',
            component: Permission,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/machine/MachineConfigPhone',
            name: 'VPN套餐(手机)',
            component: MachineConfigPhone,
            meta: {
                requireAuth: true
            }
        },{
            path: '/machine/MachineConfig',
            name: 'VPN套餐(通用)',
            component: MachineConfig,
            meta: {
                requireAuth: true
            }
        },

        {
            path: '/refund/addquery',
            name: '退款申请',
            component: addquery,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/refund/auditquery',
            name: '退款审核',
            component: auditquery,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/appVersion',
            name: '升级维护',
            component: appVersion,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/notice',
            name: '通知管理',
            component: notice,
            meta: {
                requireAuth: true
            }
        },{
            path: '/system/feedBack',
            name: '意见反馈',
            component: feedBack,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/appstore',
            name: 'AppStore提测',
            component: appstore,
            meta: {
                requireAuth: true
            }
        },  {
            path: '/pay/Config',
            name: '支付配置',
            component: Config,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/complaints/page',
            name: '客诉记录',
            component: customer,
            hidden: true,
            meta: {
                requireAuth: false
            }
        },
        {
            path: '/actcode/codepage',
            name: '激活码维护',
            component: actcode,
            hidden: true,
            meta: {
                requireAuth: false
            }
        },
        {
            path: '/actcode/space',
            name: '激活码维护',
            component: actcodespace,
            hidden: true,
            meta: {
                requireAuth: false
            }
        },
        {
            path: '/actcode/channelspace',
            name: '激活码维护',
            component: channelspace,
            hidden: true,
            meta: {
                requireAuth: false
            }
        },
        {
            path: '/actcode/spacereport',
            name: '激活码统计',
            component: spacereport,
            hidden: true,
            meta: {
                requireAuth: false
            }
        },
        {
            path: '/goods/channeluser',
            name: '批量账号管理',
            component: channeluser,
            hidden: true,
            meta: {
                requireAuth: false
            }
        },
        {
            path: '/goods/inviteuser',
            name: '邀请记录',
            component: inviteuser,
            hidden: true,
            meta: {
                requireAuth: false
            }
        },
        {
            path: '/whitelist/index',
            name: '白名单管理',
            component: whitelist,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/wxtoken/index',
            name: '微信凭证日志',
            component: wxtoken,
            meta: {
                requireAuth: true
            }
        }
    ]
}]
// 导出路由
export default new Router({
    routes,
})



// WEBPACK FOOTER //
// ./src/router/index.js